<template>
  <v-carousel hide-delimiter-background>
    <v-carousel-item v-for="(item, i) in items" :key="i">
      <div id="Graphique">
        <svg class="Fond">
          <rect
            id="Fond"
            rx="20"
            ry="20"
            x="0"
            y="0"
            width="1000"
            height="1000"
          ></rect>
        </svg>
        <div id="ID1">
          <span>{{ item["VALUE"] }} </span>
          <span v-if="item['KEY'] == 'CA HT'">{{ devise }}</span>
        </div>
        <div id="ID2">
          <span>{{ item["DAY_VALUE"] }} </span>
          <span v-if="item['KEY'] == 'CA HT'">{{ devise }}</span>
        </div>
        <div id="CA_HT">
          <span>{{ item["KEY"] }}</span>
        </div>
        <div id="DAY">
          <span>{{ item["DAY"] }}</span>
        </div>
        <img
          v-if="item['VALUE'] > item['DAY_VALUE']"
          class="Up"
          src="../../public/img/Up.png"
          srcset="../../public/img/Up.png 1x, ../../public/img/Up@2x.png 2x"
        />
        <img
          v-if="item['VALUE'] <= item['DAY_VALUE']"
          class="Down"
          src="../../public/img/Down.png"
          srcset="../../public/img/Down.png 1x, ../../public/img/Down@2x.png 2x"
        />
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: ["items", "devise"],
};
</script>
